export default {
  computed: {
    userHasProvidedFile() {
      return this.uploadedFiles
        && this.uploadedFiles.length > 0;
    },
  },
  methods: {
    fileUploading() {
      console.log('in FileUpload.fileUploading');
      this.disableSubmit = true;
    },
    // fileUploaded(values) {
    //   // this.uploadedFiles = values.files;
    //   this.disableSubmit = false;
    // },
    upload() {
      console.log('inFileUpload.upload')
      return new Promise((resolve, reject) => {
        if (this.userHasProvidedFile) {
          console.log('there is 1+ file(s) - going to upload')
          this.disableSubmit = true;
          this.uploadFiles()
            .then(() => {
              this.disableSubmit = false;
              resolve(true);
            });
        } else {
          reject('No file uploaded');
        }
      });
    },
    uploadFiles() {
      return Promise.all(
        this.uploadedFiles.map((file, i) => this.uploadFile(this.prepareFormData(i))),
      );
    },
    // This method is the default
    // Needs to be overwritten when we want to send the file to another place
    uploadFile() {
      console.log('in FileUpload.UploadFile')
    },
    initializeFormData(i) {
      const reader = new FileReader();
      reader.readAsDataURL(this.uploadedFiles[i]);

      const formData = new FormData();

      formData.append('file', this.uploadedFiles[i]);
      return formData;
    },
    // This method is the default
    // Needs to be overwritten when we want to send the file to another place
    fillFormData(formData, i) {
      const index = parseInt(i, 10) + 1;

      formData.append('uploadname', `${this.filePrefix}${this.lead.id}_${index}`);
      formData.append('agentkey', this.agent.key);
      formData.append('userkey', this.agent.userkey);
      formData.append('leadkey', this.lead.key);
      formData.append('uploadtypeid', this.fileType);
      return formData;
    },
    prepareFormData(i) {
      return this.fillFormData(this.initializeFormData(i), i);
    },
  },
};
